module.exports = __webpack_public_path__ + "img/neck opening.8309c020.png";